export function zeroFill(length: number, number: number) {
  return (Array(length).join('0') + number).slice(-length);
}

export function randomRange(min: number, max: number) {
  return Math.random() * (max - min + 1) + min;
}

export const clip = (val: number, min: number, max: number) =>
  Math.max(min, Math.min(val, max));

export const modifier = () => {
  let _key = '';
  return function (key: string, callback: () => void) {
    if (_key !== key) {
      _key = key;
      callback && callback();
    }
  };
};

// 近似値
export const closestNumber = (counts: number[], num: number) => {
  return counts.reduce(function (prev, curr) {
    return Math.abs(curr - num) < Math.abs(prev - num) ? curr : prev;
  });
};

/**
 * dispatchEvent
 * @param type
 * @param element
 */
export const dispatchEvent = (type: string, element: HTMLElement) => {
  let event;
  if (typeof Event === 'function') {
    event = new Event(type);
  } else {
    event = document.createEvent('Event');
    event.initEvent(type, true, true);
  }
  element.dispatchEvent(event);
};

export const debounce = <T extends (...args: any[]) => unknown>(
  callback: T,
  delay = 250,
): ((...args: Parameters<T>) => void) => {
  let timeoutId: number // Node.jsの場合はNodeJS.Timeout型にする
  return (...args) => {
    window.clearTimeout(timeoutId)
    timeoutId = window.setTimeout(() => callback(...args), delay)
  }
}
